export const getters = {
    TICKET_DETAIL: (state) => state.ticket_detail
}
